<template>
  <trustpilot-logo
    v-if="platform === 'trustpilot'"
    class="platform-glyph platform-glyph--trustpilot"
  />
  <google-logo
    v-else-if="platform === 'google'"
    class="platform-glyph platform-glyph--google"
  />
  <reco-logo
    v-else-if="platform === 'reco'"
    class="platform-glyph platform-glyph--reco"
  />
</template>

<script>
import TrustpilotLogo from './TrustpilotLogo.vue';
import GoogleLogo from './GoogleLogo.vue';
import RecoLogo from './RecoLogo.vue';

export default {
  name: 'PlatformGlyph',

  components: {
    TrustpilotLogo,
    GoogleLogo,
    RecoLogo,
  },

  props: {
    platform: {
      type: String,
      required: true,
      validator: (value) => ['trustpilot', 'google', 'reco'].includes(value),
    },
  },
};
</script>
